module.exports = __webpack_public_path__ + "static/media/orska.1e81a3ac.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/orska.webp
// module id = 646
// module chunks = 0